import { ComponentType } from 'react';
import { WidgetConfig, WidgetProps } from '../contracts/widget.contract';

export interface RegisteredWidget {
  config: WidgetConfig;
  component: ComponentType<WidgetProps>;
}

class DashboardWidgetRegistry {
  private widgets: Map<string, RegisteredWidget> = new Map();

  register(config: WidgetConfig, component: ComponentType<WidgetProps>) {
    if (this.widgets.has(config.id)) {
      console.warn(`Widget with ID ${config.id} is already registered. Overwriting.`);
    }
    this.widgets.set(config.id, { config, component });
  }

  getWidget(id: string): RegisteredWidget | undefined {
    return this.widgets.get(id);
  }

  getAllWidgets(): RegisteredWidget[] {
    return Array.from(this.widgets.values());
  }

  getWidgetsByCategory(category: WidgetConfig['category']): RegisteredWidget[] {
    return this.getAllWidgets().filter(w => w.config.category === category);
  }
}

export const widgetRegistry = new DashboardWidgetRegistry();
